/**
 * DuplicateProjectButton Component
 * Button to duplicate the current project
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Copy } from 'lucide-react';

export const DuplicateProjectButton = ({ projectId, duplicateProject, isSaving }) => {
  if (!projectId) return null;
  
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={duplicateProject}
      disabled={isSaving}
      className="border-zinc-700 px-2 hidden md:flex"
      data-testid="duplicate-project"
      title="Duplicate Project"
    >
      <Copy className="w-4 h-4" />
    </Button>
  );
};

export default DuplicateProjectButton;
